export default __webpack_public_path__ + "static/media/background-1.61016ed6.png";